"use strict";

import helpers from "./_helpers";

const GMap = () => {
    const init = () => {
        let $maps, $autocomplete;
        $(function () {
            var loadedMaps = false;
            $maps = $('.js-map');
            $autocomplete = $('.js-autocomplete');

            if(($maps.length || $autocomplete.length) && !loadedMaps) {
                var mapsScript = document.createElement('script');
                mapsScript.src = 'https://maps.googleapis.com/maps/api/js?callback=initGoogleMap&libraries=places&key='+ ($maps.length ? $maps.data('key') : $autocomplete.parents('form').data('maps-key'));
                mapsScript.defer = true;
                document.body.appendChild(mapsScript);
                loadedMaps = true;
            }
        });

        window.initGoogleMap = function(){
            $maps.each(function () {
                addLocationsToMapGlobal($(this));
            });

            $autocomplete.each(function() {
                var autocomplete = new google.maps.places.Autocomplete($(this)[0], {types: ['address']});
                autocomplete.setComponentRestrictions({
                    country: ["au"]
                });

                // Bias the autocomplete object to the user's geographical location, as supplied by the browser's 'navigator.geolocation' object.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {
                        var geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        var circle = new google.maps.Circle({center: geolocation, radius: position.coords.accuracy});
                        autocomplete.setBounds(circle.getBounds());
                    });
                }
            });
        }

        window.addLocationsToMapGlobal = function($map, location_data = false, searchTerm = ''){
            let lat = $map.data('lat'), lng = $map.data('lng');
            let pin = $map.data('pin');
            let active_pin = $map.data('pin-active') !== undefined ? $map.data('pin-active') : $map.data('pin');
            let zoom = $map.data('zoom');
            let locations = $map.data('locations');
            let country = $map.data('country');
            let has_results= true;
            let map_location = $('.js-agent-card');
            let service

            if(location_data) {
                locations = JSON.parse(location_data);

                if(locations.length == 0) {
                    has_results = false;
                }
            }

            let map_obj = new google.maps.Map($map[0], {
                center: {lat, lng},
                zoom: parseFloat(zoom),
                disableDefaultUI: true,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            });

            let i = 1;
            let points = [];
            var bounds = new google.maps.LatLngBounds();
            locations.forEach((item) => {
                if (item.lat && item.long) {
                    bounds.extend(new google.maps.LatLng(item.lat, item.long));

                    points[i] = new google.maps.Marker({
                        position: {
                            "lat": parseFloat(item.lat),
                            "lng": parseFloat(item.long)
                        },
                        map: map_obj,
                        icon: pin,
                        zIndex: 99,
                        title: item.title,
                    });
                    points[i]['array_id'] = i;
                    points[i]['id'] = item.id;

                    google.maps.event.clearInstanceListeners(points[i]);
                    points[i].addListener('click', function () {
                        points.forEach((item) => {
                            if (item.id == this.id) {
                                item.setIcon(active_pin);
                            } else {
                                item.setIcon(pin);
                            }
                        });

                        let $agent_card_container = $('.js-map-list-container');
                        let latLng = this.getPosition();
                        // map_obj.setCenter(latLng);
                        // map_obj.setZoom(8);

                        // $agent_card_container.find('.js-agent-card').removeClass('active');
                        let $agent_card = $agent_card_container.find('.js-agent-card[data-id="' + this.id + '"]');
                        $agent_card.addClass('active');

                        if(helpers.isMobile()) {
                            var agent_slider = $('.js-agent-slider-container')[0].swiper;

                            if(agent_slider) {
                                agent_slider.slideTo((this.array_id - 1));
                            }
                        } else {
                            let scrollTop = $agent_card_container.scrollTop() + $agent_card.offset().top - $agent_card_container.offset().top;
                            $agent_card_container.animate({
                                scrollTop: scrollTop
                            });
                        }
                    });
                    i++;
                }
            });

            /** search */
            if (searchTerm) {
                const request = {
                    query: `${searchTerm} ${country}`,
                    fields: ["all"],
                };
    
                service = new google.maps.places.PlacesService(map_obj)
    
                service.findPlaceFromQuery(request, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                        map_obj.setCenter(results[0].geometry.location);

                        /** attempt to find the nearest marker and zoom out the map until the nearest marker is visible */
                        let markers = []

                        locations.forEach((item) => {
                            markers.push({
                                "lat": parseFloat(item.lat),
                                "lng": parseFloat(item.long)
                            })
                        })

                        calculateDistances(markers, map_obj.getCenter(), map_obj);
                        /** end */
                        $('.js-agent-nearby-message').show();
                    } else {
                        /** clear markers */
                        points.forEach(function(point) {
                            point.setMap(null); 
                        });

                        points = []

                        $('.js-agent-results').html(`
                            <div class="ajax-no-results">
                                <h3>Sorry!</h3>
                                <p>We couldn't find any agents with that term.</p>
                            </div>`
                        )
                    }
                });

                if(has_results) {
                    // Don't zoom in too far on only one marker
                    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat()+0.0010, bounds.getNorthEast().lng()+0.0010);
                        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat()-0.0010, bounds.getNorthEast().lng()-0.0010);
                        bounds.extend(extendPoint1);
                        bounds.extend(extendPoint2);
                    }
                    map_obj.fitBounds(bounds);
                }
            }
            /** end search */

            map_location.off('mouseenter mouseleave');
            map_location.on('mouseenter', function () {
                let $listing = $(this);
                let $listings = map_location;
                $listings.removeClass('highlight');
                $listing.addClass('highlight');
                points.forEach((item) => {
                    if (item.id == $listing.data('id')) {
                        item.setIcon(active_pin);
                    } else {
                        item.setIcon(pin);
                    }
                });
            });

            map_location.on('mouseleave', function () {
                let $listing = $(this);
                let $listings = map_location;
                $listings.removeClass('highlight');
                points.forEach((item) => {
                    if (item.id == $listing.data('id')) {
                        item.setIcon(pin);
                    }
                });
            });

            map_location.on('click', function () {
                let $listings = map_location;
                $listings.removeClass('active');

                $(this).addClass('active');
                points.forEach((item) => {
                    if (item.id == $(this).data('id')) {
                        let latLng = item.getPosition();
                        map_obj.setCenter(latLng);
                        // map_obj.setZoom(8);
                    }
                });

                if(helpers.isMobile()) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $map.offset().top - 100
                    });
                }
            });

            var pan_listener = null
            var zoom_listener = null

            if(pan_listener){
                google.maps.event.removeListener(pan_listener)
            }
            pan_listener = map_obj.addListener("center_changed", () => {
                $('.js-agent-nearby-message').hide();
                points.forEach((item) => {
                    if(!map_obj.getBounds().contains(item.getPosition())){
                        let hiddenMapLocation = map_location.filter('[data-id="'+item.id+'"]');
                        hiddenMapLocation.each(function() {
                            $(this).parents('.swiper-slide').hide();
                        });
                    }else{
                        let hiddenMapLocation = map_location.filter('[data-id="'+item.id+'"]');
                        hiddenMapLocation.each(function() {
                            $(this).parents('.swiper-slide').show();
                        });
                    }
                });

                processAgentListing(map_location);
            });

            if(zoom_listener){
                google.maps.event.removeListener(zoom_listener)
            }
            zoom_listener = map_obj.addListener("zoom_changed", () => {
                $('.js-agent-nearby-message').hide();
                points.forEach((item) => {
                    if(!map_obj.getBounds().contains(item.getPosition())){
                        map_location.filter('[data-id="'+item.id+'"]').parents('.swiper-slide').hide();
                    }else{
                        map_location.filter('[data-id="'+item.id+'"]').parents('.swiper-slide').show();
                    }
                });

                processAgentListing(map_location);
            });
        }

        function processAgentListing(map_location) {
            if(map_location.filter(':visible').length > 0) {
                $('.js-agent-not-on-map-message').hide();
            } else {
                $('.js-agent-not-on-map-message').show();
            }

            var $agent_slider_container = $('.js-agent-slider-container');
            var agent_slider_array = [];

            if ($agent_slider_container.length > 0) {
                $agent_slider_container.each(function (index) {
                    var slider = this;
                    helpers.agentSliderInit(slider, index);
                });
            }
        }

        function calculateDistances(markers, center, map) {
            markers.forEach(function(marker) {
                var dx = Math.abs(marker.lat - center.lat());
                var dy = Math.abs(marker.lng - center.lng());
                marker.distance = Math.sqrt(dx * dx + dy * dy);
            });

            zoomToNearestMarker(markers, map)
        }

        function zoomToNearestMarker(markers, map) {
            markers.sort(function(a, b) {
                return a.distance - b.distance;
            });
            
            var nearestMarker = markers[0];
            
            var bounds = new google.maps.LatLngBounds();
            bounds.extend(nearestMarker);
            
            map.fitBounds(bounds);
            map.setZoom(9);
        }

        window.addLocationsToAgentMap = function(location_data, searchTerm, hasMatch){
            var $ajax_map = $('.js-ajax-map');

            $('.js-agent-nearby-message').hide();

            if($ajax_map.length) {
                addLocationsToMapGlobal($ajax_map, location_data, !hasMatch ? searchTerm : null);
            }
        }
    };

    return {
        init: init
    };
};

export default GMap;